import React, { useEffect, useState } from 'react';

export default function TeachingNotes() {
    const [posts, setPosts] = useState([]);
    useEffect(() => {
        const controller = new AbortController();
        fetch('/blog/feed.json', { signal: controller.signal }).then(r => r.ok ? r.json() : null)
            .then(data => { if (Array.isArray(data?.posts)) setPosts(data.posts); }).catch(() => {});
        return () => controller.abort();
    }, []);
    return <section className="py-12 border-t border-book-line" aria-labelledby="teaching-notes-heading">
        <div className="max-w-6xl mx-auto px-4 md:px-8">
            <div className="flex flex-wrap gap-4 items-end justify-between">
                <div><p className="text-sm text-book-accent mb-2">From Danielle’s desk</p><h2 id="teaching-notes-heading" className="font-display text-2xl md:text-3xl font-bold">Teaching notes</h2><p className="text-book-muted mt-3">Practical ideas for reading closely, writing clearly and supporting your child’s English learning.</p></div>
                <a href="/blog" className="font-display text-book-accent underline shrink-0">Explore the blog →</a>
            </div>
            {posts.length > 0 && <div className="grid md:grid-cols-3 gap-5 mt-6">{posts.map(p => <article key={p.slug} className="rounded-2xl border border-book-line bg-book-page p-5 min-w-0">
                <p className="text-xs text-book-muted"><time dateTime={p.date}>{p.date}</time>{p.category ? ' · ' + p.category : ''}</p>
                <h3 className="font-display font-semibold text-xl mt-3"><a href={'/blog/' + p.slug} className="hover:text-book-accent">{p.title}</a></h3><p className="text-book-muted mt-3 text-sm leading-relaxed">{p.excerpt}</p><a className="inline-block mt-4 text-sm text-book-accent underline" href={'/blog/' + p.slug}>Read article</a>
            </article>)}</div>}
        </div>
    </section>;
}
